import {Account} from "@app/_model/account";
import {Logger} from "@app/logger";

export abstract class BackendData {
  protected readonly log = new Logger();

  id: number;
  inserted?: Date;
  insertedBy?: Account;
  updated?: Date;
  updatedBy?: Account;

  protected constructor(
    id: number,
    inserted: Date | undefined,
    insertedBy: Account | undefined,
    updated: Date | undefined,
    updatedBy: Account | undefined
  ) {
    this.id = id;
    this.inserted = inserted;
    this.insertedBy = (!insertedBy) ? insertedBy : Account.of(insertedBy);
    this.updated = updated;
    this.updatedBy = (!updatedBy) ? updatedBy : Account.of(updatedBy);
  }
}

export interface BackendDataList<T> {
  count: number;
  items: T[];
}
